<template>
  <q-card flat bordered>
    <div class="q-mx-auto q-py-sm">
      <div
        class="q-pa-xs text-body1 text-weight-bold"
        :class="this.$q.dark.mode === true ? '' : 'text-primary '"
      >
        Comparison with Prev Fiscal Year
      </div>
      <div class="q-gutter-sm">
        <q-radio
          v-model="filterOption"
          val="default"
          label="Default"
          color="teal"
          keep-color
        />
        <q-radio
          v-model="filterOption"
          val="individual_quarter"
          label="Individual Quarter"
          color="primary"
          keep-color
        />
        <q-radio
          v-model="filterOption"
          val="year_end"
          label="Year End"
          color="cyan"
          keep-color
        />
      </div>

      <q-btn
        class="q-ma-sm justify-end"
        :color="this.$q.dark.mode === true ? 'grey-8' : 'primary'"
        size="sm"
        @click="exportToCSV"
        >Export as CSV
      </q-btn>

      <q-card flat bordered class="row q-px-sm q-mx-xs q-mb-sm q-pb-xs">
        <div class="col-6 q-pa-xs q-px-md-md">
          <q-select
            v-model="selected_fiscal_year"
            :options="FiscalYear"
            label="Fiscal Year"
            @update:model-value="onClickSearch"
          >
            <q-tooltip class="bg-primary text-white"
              >select fiscal year</q-tooltip
            >
          </q-select>
        </div>
        <div class="col-6 q-pa-xs q-px-md-md">
          <q-select
            v-if="filterOption === 'year_end'"
            v-model="selected_prev_fiscal_year"
            :options="FiscalYear"
            label="Prev Fiscal Year"
            @update:model-value="onClickSearch"
          >
            <q-tooltip class="bg-primary text-white"
              >select Prev fiscal year</q-tooltip
            >
          </q-select>
          <q-select
            v-if="filterOption !== 'year_end'"
            v-model="selected_quarter"
            :options="Quarter"
            label="Quarter"
            @update:model-value="onClickSearch"
          >
            <q-tooltip class="bg-primary text-white">select quarter</q-tooltip>
          </q-select>
        </div>
        <!-- <div class="col-2 q-pa-sm-md q-py-xs-md q-px-xs-xs">
          <q-btn
            no-caps
            color="blue-6"
            flat
            icon="search"
            class="q-ma-auto q-pa-auto"
            @click="onClickSearch"
          >
            <q-tooltip class="bg-primary text-white">filter</q-tooltip>
          </q-btn>
        </div> -->
      </q-card>

      <q-table
        v-if="stockFYComparisonData.length"
        flat
        bordered
        hide-bottom
        :dense="$q.screen.lt.md"
        :class="
          this.$q.dark.mode === true
            ? 'table-sticky-header-column-dark'
            : 'table-sticky-header-column'
        "
        :columns="
          filterOption !== 'default' ? stockFYColumns : stockFYComparisonColumns
        "
        :rows="computedStockFYComparisonData"
        separator="cell"
        :pagination="{
          rowsPerPage: 0,
        }"
      >
        <template v-slot:body-cell="props">
          <q-td :props="props">
            {{ props.value }} {{ props.col.name == "diff" ? "%" : "" }}
          </q-td>
        </template>

        <template v-slot:body-cell-dimension="props">
          <q-td :props="props">
            {{ props.value }}
          </q-td>
        </template>
      </q-table>
    </div>
  </q-card>
</template>

<script>
import { ref, onMounted, watch, reactive, computed } from "vue";
import useCore from "src/use/core";
import useUtils from "src/use/utils";

export default {
  name: "StockWiseFYComparison",
  props: {
    symbol: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { stockSearch, stockReport, sectorDimension } = useCore();
    const { amountConversion, getUniqueFiscalYears } = useUtils();

    const stock = ref(null);
    const ignoreDimensions = ["fiscal_year", "quarter", "book_close_date"];

    const FiscalYear = ref([]);
    const Quarter = ["q1", "q2", "q3", "q4"];

    const selected_quarter = ref("q1");
    const selected_fiscal_year = ref("079/080");
    const selected_prev_fiscal_year = ref("079/080");

    const filterOption = ref("default");

    const latestFYQuarter = ref("");
    const previousFYQuarter1 = ref("");
    const previousFYQuarter2 = ref("");
    const previousFYQuarter3 = ref("");
    const previousFYQuarter4 = ref("");

    const stockFYColumns = reactive([
      {
        name: "dimension",
        label: "Particulars",
        field: "dimension",
        sortable: true,
        align: "left",
        style: "max-width: 50px",
        classes: "ellipsis",
      },
      {
        name: "diff",
        label: "Diff (%)",
        field: "diff",
        align: "right",
        // style: "max-width: 10px",
        classes: "ellipsis",
        style: (row) => {
          return row.diff === "-"
            ? ""
            : parseFloat(row.diff) == 0
            ? ""
            : parseFloat(row.diff) > 0
            ? "color:green"
            : "color:red";
        },
      },
      {
        name: "latest_value",
        label: latestFYQuarter,
        field: "latest_value",
        align: "center",
        // style: "max-width: 10px",
        classes: "ellipsis",
      },
      {
        name: "previous_fy_valueq1",
        label: previousFYQuarter1,
        field: "previous_fy_valueq1",
        align: "right",
        // style: "max-width: 10px",
        classes: "ellipsis",
      },
    ]);

    const stockFYComparisonColumns = reactive([
      {
        name: "dimension",
        label: "Particulars",
        field: "dimension",
        sortable: true,
        align: "left",
        style: "max-width: 50px",
        classes: "ellipsis",
      },
      {
        name: "diff",
        label: "Diff (%)",
        field: "diff",
        align: "right",
        // style: "max-width: 10px",
        classes: "ellipsis",
        style: (row) => {
          return row.diff === "-"
            ? ""
            : parseFloat(row.diff) == 0
            ? ""
            : parseFloat(row.diff) > 0
            ? "color:green"
            : "color:red";
        },
      },
      {
        name: "latest_value",
        label: latestFYQuarter,
        field: "latest_value",
        align: "right",
        // style: "max-width: 10px",
        classes: "ellipsis",
        style: (row) => {
          return row.diff === "-"
            ? ""
            : parseFloat(row.diff) == 0
            ? ""
            : parseFloat(row.diff) > 0
            ? "color:green"
            : "color:red";
        },
      },
      {
        name: "previous_fy_valueq1",
        label: previousFYQuarter1,
        field: "previous_fy_valueq1",
        align: "right",
        // style: "max-width: 10px",
        classes: "ellipsis",
        style: (row) => {
          return row.diff === "-"
            ? ""
            : parseFloat(row.diff) == 0
            ? ""
            : parseFloat(row.diff) > 0
            ? "color:green"
            : "color:red";
        },
      },
      {
        name: "previous_fy_valueq2",
        label: previousFYQuarter2,
        field: "previous_fy_valueq2",
        align: "right",
        style: "max-width: 10px",
        classes: "ellipsis",
      },
      {
        name: "previous_fy_valueq3",
        label: previousFYQuarter3,
        field: "previous_fy_valueq3",
        align: "right",
        style: "max-width: 10px",
        classes: "ellipsis",
      },
      {
        name: "previous_fy_valueq4",
        label: previousFYQuarter4,
        field: "previous_fy_valueq4",
        align: "right",
        style: "max-width: 10px",
        classes: "ellipsis",
      },
    ]);
    const stockFYComparisonData = ref([]);
    const sectorDimensions = ref([]);
    const sectorDimensionsKeys = ref([]);

    const reportData = ref([]);

    const getReportsComparison = (symbol) => {
      stockSearch(symbol)
        .then((data) => {
          var stock = data;

          sectorDimension(stock.sector).then((res) => {
            const customOrder = [
              "paidup_capital",
              "reserve",
              "retained_earning",
              "deposit",
              "loan",
              "net_interest_income",
              "net_fee_commission_income",
              "operating_profit",
              "net_profit",
              "distributable_profit",
              "eps",
              "eps_a",
              "dps",
              "net_worth",
              "roe",
              "roa",
              "npl",
              "capital_fund_to_rwa",
              "total_assets",
              "total_liabilities",
              "net_interest_income",
              "net_fee_commission_income",
              "cost_of_fund",
              "base_rate",
              "interest_spread",
              "cd_ratio",
            ];

            const orderedData = res.data.reduce(
              (acc, item) => {
                if (customOrder.includes(item.name)) {
                  acc.orderedItems.push(item);
                } else {
                  acc.remainingItems.push(item);
                }
                return acc;
              },
              { orderedItems: [], remainingItems: [] }
            );

            orderedData.orderedItems.sort(
              (a, b) =>
                customOrder.indexOf(a.name) - customOrder.indexOf(b.name)
            );

            const finalOrderedData = [
              ...orderedData.orderedItems,
              ...orderedData.remainingItems,
            ];

            // sectorDimensions.value = finalOrderedData;
            sectorDimensionsKeys.value = finalOrderedData;

            // const orderedItems = res.data.filter((item) =>
            //   customOrder.includes(item.name)
            // );

            // orderedItems.sort(
            //   (a, b) =>
            //     customOrder.indexOf(a.name) - customOrder.indexOf(b.name)
            // );

            // const remainingItems = res.data.filter(
            //   (item) => !customOrder.includes(item.name)
            // );

            // const orderedData = [...orderedItems, ...remainingItems];

            // sectorDimensions.value = orderedData;

            res.data.map((fieldName) => {
              if (fieldName.name == "dps") fieldName.verbose_name = "Dis EPS";
              if (fieldName.name == "eps")
                fieldName.verbose_name = "EPS (Reported)";
              if (fieldName.name == "eps_a")
                fieldName.verbose_name = "EPS (Annualized)";
            });

            stockReport(stock.id).then((res) => {
              FiscalYear.value = getUniqueFiscalYears(res.data);
              reportData.value = res.data;
              selected_quarter.value = res.data[0].quarter;
              selected_fiscal_year.value = res.data[0].fiscal_year;

              const nonNullKeys = Object.keys(res.data[0]).filter(
                (key) => res.data[0][key] !== null
              );

              sectorDimensions.value = sectorDimensionsKeys.value.filter(
                (item) => nonNullKeys.includes(item.name)
              );

              // var latestStockReport = res.data[0];

              var latestFiscalYearReport = res.data?.filter(
                (r) => r.fiscal_year == selected_fiscal_year.value
              );

              var latestStockReport = latestFiscalYearReport?.filter((item) => {
                return item.quarter === selected_quarter.value;
              })[0];

              var latestStockReportOthers = latestFiscalYearReport.filter(
                (item) => {
                  return item.quarter !== latestStockReport.quarter;
                }
              );

              latestFYQuarter.value = latestStockReport
                ? latestStockReport.quarter?.toUpperCase() +
                  " - " +
                  latestStockReport.fiscal_year
                : "-";

              var previousFiscalYearReport = res.data.filter(
                (r) =>
                  r.fiscal_year.split("/")[1] ==
                  latestStockReport.fiscal_year.split("/")[0]
              );

              var previousStockReport = previousFiscalYearReport.filter(
                (item) => {
                  return item.quarter === latestStockReport.quarter;
                }
              );

              var previousStockReportOthers = [
                ...latestStockReportOthers,
                ...previousFiscalYearReport.filter((item) => {
                  return item.quarter !== latestStockReport.quarter;
                }),
              ];

              var previousFiscalYearReport1 = previousStockReportOthers[0];
              var previousFiscalYearReport2 = previousStockReportOthers[1];
              var previousFiscalYearReport3 = previousStockReportOthers[2];

              previousFYQuarter1.value = previousStockReport[0]
                ? previousStockReport[0].quarter.toUpperCase() +
                  " - " +
                  previousStockReport[0].fiscal_year
                : "-";

              previousFYQuarter2.value = previousFiscalYearReport1
                ? previousFiscalYearReport1.quarter.toUpperCase() +
                  " - " +
                  previousFiscalYearReport1.fiscal_year
                : "-";

              previousFYQuarter3.value = previousFiscalYearReport2
                ? previousFiscalYearReport2.quarter.toUpperCase() +
                  " - " +
                  previousFiscalYearReport2.fiscal_year
                : "-";

              previousFYQuarter4.value = previousFiscalYearReport3
                ? previousFiscalYearReport3.quarter.toUpperCase() +
                  " - " +
                  previousFiscalYearReport3.fiscal_year
                : "-";

              stockFYComparisonData.value = sectorDimensions.value
                .filter((dim) => !ignoreDimensions.includes(dim.name))
                .map((dim) => {
                  var latestValue = latestStockReport
                    ? latestStockReport[dim.name]
                      ? parseFloat(latestStockReport[dim.name]).toFixed(2)
                      : "-"
                    : "-";

                  var latestVal = latestStockReport
                    ? latestStockReport[dim.name]
                      ? amountConversion(latestValue)
                      : "-"
                    : "-";

                  var previousFYValue1 = previousStockReport[0]
                    ? previousStockReport[0][dim.name]
                      ? parseFloat(previousStockReport[0][dim.name])?.toFixed(2)
                      : "-"
                    : "-";
                  var previousVal1 = previousStockReport[0]
                    ? previousStockReport[0][dim.name]
                      ? amountConversion(previousFYValue1)
                      : "-"
                    : "-";

                  var previousFYValue2 = previousFiscalYearReport1
                    ? previousFiscalYearReport1[dim.name]
                      ? parseFloat(
                          previousFiscalYearReport1[dim.name]
                        )?.toFixed(2)
                      : "-"
                    : "-";
                  var previousVal2 = previousFiscalYearReport1
                    ? previousFiscalYearReport1[dim.name]
                      ? amountConversion(previousFYValue2)
                      : "-"
                    : "-";

                  var previousFYValue3 = previousFiscalYearReport2
                    ? previousFiscalYearReport2[dim.name]
                      ? parseFloat(
                          previousFiscalYearReport2[dim.name]
                        )?.toFixed(2)
                      : "-"
                    : "-";
                  var previousVal3 = previousFiscalYearReport2
                    ? previousFiscalYearReport2[dim.name]
                      ? amountConversion(previousFYValue3)
                      : "-"
                    : "-";

                  var previousFYValue4 = previousFiscalYearReport3
                    ? previousFiscalYearReport3[dim.name]
                      ? parseFloat(
                          previousFiscalYearReport3[dim.name]
                        )?.toFixed(2)
                      : "-"
                    : "-";
                  var previousVal4 = previousFiscalYearReport3
                    ? previousFiscalYearReport3[dim.name]
                      ? amountConversion(previousFYValue4)
                      : "-"
                    : "-";

                  var diff =
                    latestValue != "-" && previousFYValue1 != "-"
                      ? parseFloat(
                          ((latestValue - previousFYValue1) /
                            previousFYValue1) *
                            100
                        ).toFixed(2)
                      : "-";

                  return {
                    dimension: dim.verbose_name,
                    latest_value: latestVal,
                    previous_fy_valueq1: previousVal1,
                    previous_fy_valueq2: previousVal2,
                    previous_fy_valueq3: previousVal3,
                    previous_fy_valueq4: previousVal4,
                    diff: diff,
                  };
                });
            });
          });
        })
        .catch((error) => {
          console.log(error);
        });
    };

    function onClickSearch(preciousYear) {
      var latestStockReport = reportData.value
        .filter((item) => {
          return item.fiscal_year == selected_fiscal_year.value;
        })
        .filter((i) => {
          return i.quarter == selected_quarter.value;
        });

      var latestStockReportOthers = reportData.value
        .filter((item) => {
          return item.fiscal_year == selected_fiscal_year.value;
        })
        .filter((i) => {
          return i.quarter !== selected_quarter.value;
        });

      latestFYQuarter.value = latestStockReport[0]
        ? latestStockReport[0].quarter?.toUpperCase() +
          " - " +
          latestStockReport[0].fiscal_year
        : "-";

      var previousFiscalYearReport =
        preciousYear && filterOption.value === "year_end"
          ? reportData.value.filter((r) => r.fiscal_year === preciousYear)
          : reportData.value.filter(
              (r) =>
                r.fiscal_year.split("/")[1] ==
                selected_fiscal_year.value.split("/")[0]
            );

      var previousStockReport = previousFiscalYearReport.filter((item) => {
        return item.quarter === latestStockReport[0].quarter;
      });

      var previousStockReportOthers = [
        ...latestStockReportOthers,
        ...previousFiscalYearReport.filter((item) => {
          return item.quarter !== latestStockReport[0].quarter;
        }),
      ];

      var previousFiscalYearReport1 = previousStockReportOthers[0];
      var previousFiscalYearReport2 = previousStockReportOthers[1];
      var previousFiscalYearReport3 = previousStockReportOthers[2];

      previousFYQuarter1.value = previousStockReport[0]
        ? previousStockReport[0].quarter.toUpperCase() +
          " - " +
          previousStockReport[0].fiscal_year
        : "-";

      previousFYQuarter2.value = previousFiscalYearReport1
        ? previousFiscalYearReport1.quarter.toUpperCase() +
          " - " +
          previousFiscalYearReport1.fiscal_year
        : "-";

      previousFYQuarter3.value = previousFiscalYearReport2
        ? previousFiscalYearReport2.quarter.toUpperCase() +
          " - " +
          previousFiscalYearReport2.fiscal_year
        : "-";

      previousFYQuarter4.value = previousFiscalYearReport3
        ? previousFiscalYearReport3.quarter.toUpperCase() +
          " - " +
          previousFiscalYearReport3.fiscal_year
        : "-";

      stockFYComparisonData.value = sectorDimensions.value
        .filter((dim) => !ignoreDimensions.includes(dim.name))
        .map((dim) => {
          var latestValue = latestStockReport[0]
            ? latestStockReport[0][dim.name]
              ? parseFloat(latestStockReport[0][dim.name]).toFixed(2)
              : "-"
            : "-";

          var latestVal = latestStockReport[0]
            ? latestStockReport[0][dim.name]
              ? amountConversion(latestValue)
              : "-"
            : "-";

          var previousFYValue1 = previousStockReport[0]
            ? previousStockReport[0][dim.name]
              ? parseFloat(previousStockReport[0][dim.name])?.toFixed(2)
              : "-"
            : "-";
          var previousVal1 = previousStockReport[0]
            ? previousStockReport[0][dim.name]
              ? amountConversion(previousFYValue1)
              : "-"
            : "-";

          var previousFYValue2 = previousFiscalYearReport1
            ? previousFiscalYearReport1[dim.name]
              ? parseFloat(previousFiscalYearReport1[dim.name])?.toFixed(2)
              : "-"
            : "-";
          var previousVal2 = previousFiscalYearReport1
            ? previousFiscalYearReport1[dim.name]
              ? amountConversion(previousFYValue2)
              : "-"
            : "-";

          var previousFYValue3 = previousFiscalYearReport2
            ? previousFiscalYearReport2[dim.name]
              ? parseFloat(previousFiscalYearReport2[dim.name])?.toFixed(2)
              : "-"
            : "-";
          var previousVal3 = previousFiscalYearReport2
            ? previousFiscalYearReport2[dim.name]
              ? amountConversion(previousFYValue3)
              : "-"
            : "-";

          var previousFYValue4 = previousFiscalYearReport3
            ? previousFiscalYearReport3[dim.name]
              ? parseFloat(previousFiscalYearReport3[dim.name])?.toFixed(2)
              : "-"
            : "-";
          var previousVal4 = previousFiscalYearReport3
            ? previousFiscalYearReport3[dim.name]
              ? amountConversion(previousFYValue4)
              : "-"
            : "-";

          var diff =
            latestValue != "-" && previousFYValue1 != "-"
              ? parseFloat(
                  ((latestValue - previousFYValue1) / previousFYValue1) * 100
                ).toFixed(2)
              : "-";

          return {
            dimension: dim.verbose_name,
            latest_value: latestVal,
            previous_fy_valueq1: previousVal1,
            previous_fy_valueq2: previousVal2,
            previous_fy_valueq3: previousVal3,
            previous_fy_valueq4: previousVal4,
            diff: diff,
          };
        });
    }

    onMounted(() => {
      getReportsComparison(props.symbol);
    });

    watch(props, (newProps, oldProps) => {
      getReportsComparison(newProps.symbol);
    });

    const computedStockFYComparisonData = computed(() => {
      let result = [];

      if (filterOption.value === "default") {
        result = stockFYComparisonData.value;
      } else if (filterOption.value === "individual_quarter") {
        result = stockFYComparisonData.value.map((i) => ({
          dimension: i.dimension,
          latest_value: i.latest_value,
          previous_fy_valueq1: i.previous_fy_valueq1,
          diff: i.diff,
        }));
      } else if (filterOption.value === "year_end") {
        result = stockFYComparisonData.value.map((i) => ({
          dimension: i.dimension,
          latest_value: i.latest_value,
          previous_fy_valueq1: i.previous_fy_valueq1,
          diff: i.diff,
        }));
      }

      return result;
    });

    function getIndexNumber(argument) {
      return FiscalYear.value.indexOf(argument);
    }

    watch(filterOption, () => {
      if (filterOption.value === "year_end") {
        selected_quarter.value = "q4";
        selected_fiscal_year.value = FiscalYear.value[1];
        selected_prev_fiscal_year.value =
          FiscalYear.value[getIndexNumber(selected_fiscal_year.value) + 1];
        onClickSearch(selected_prev_fiscal_year.value);
      }
    });

    const convertToCSV = (data, type) => {
      if (data.length === 0) {
        return "";
      }

      // Mapping function to replace header text
      const mapHeader = (header) => {
        switch (header) {
          case "latest_value":
            return latestFYQuarter.value;
          case "previous_fy_valueq1":
            return previousFYQuarter1.value;
          case "previous_fy_valueq2":
            return previousFYQuarter2.value;
          case "previous_fy_valueq3":
            return previousFYQuarter3.value;
          case "previous_fy_valueq4":
            return previousFYQuarter4.value;
          default:
            return header;
        }
      };

      // Get the original headers and map them
      const originalHeaders = Object.keys(data[0]);
      const headers = originalHeaders.map(mapHeader);

      let csv = [];
      csv.unshift(headers.join(","));

      // Add chukul.com Watermark to the CSV data
      csv.unshift(["chukul.com"]);

      // Iterate over data and generate rows
      for (const item of data) {
        const row = originalHeaders.map((header) => {
          return item[header];
        });

        csv.push(row.join(","));
      }

      return csv.join("\n");
    };

    const downloadCSV = (data, filename) => {
      const csvString = convertToCSV(data);
      const blob = new Blob([csvString], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      a.style.display = "none";

      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    };

    const exportToCSV = () => {
      downloadCSV(computedStockFYComparisonData.value, "export.csv");
    };

    return {
      stockFYColumns,
      stockFYComparisonColumns,
      stockFYComparisonData,
      computedStockFYComparisonData,

      Quarter,
      FiscalYear,
      selected_quarter,
      selected_fiscal_year,
      selected_prev_fiscal_year,
      onClickSearch,

      filterOption,
      exportToCSV,
    };
  },
};
</script>
